import React from "react";
import styles from "./ctaSection.module.css";
import CTAButton from "../../../v2/common/CTA-Button/cta-button";




const CTASection:  React.FC<({text: string, subText: string})> = props => {

    return (
        <section className={styles.section}>
            <div  className={styles.innerContainer}>

                <div className={styles.textContainer}>
                    <h2>
                        {props.text}
                    </h2>
                    <h2>
                        {props.subText}
                    </h2>
                </div>
                <div className={styles.buttonContainer}>
                    <a href="/contact" className={styles.btnOutline}>
                        Start a project
                    </a>
                </div>
            </div>
        </section>
    );
};

export default CTASection;
